import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const DeviceAlertsViewModule = new Module({
  id: 'DEVICE-ALERT:RESULT-TABLE',
  name: 'Device Alerts',
  label: 'Device Alerts',
  path: 'device-alert',
  Component: ComponentLoader(
    lazy(() => import('src/content/reports/DeviceAlerts/View'))
  )
});

const DeviceAlertsModules = [DeviceAlertsViewModule];

export default new ModuleBundle('DeviceAlerts', DeviceAlertsModules);
